import { Pagination } from "antd"
import { ChevronLeftIcon, ChevronRightIcon } from "@heroicons/react/24/outline"

type Props = {
  page: number
  total: number
  onChange: (page: number) => void
}

const CustomPagination: React.FC<Props> = ({ page, total, onChange }) => {
  return (
    <Pagination
      current={page}
      onChange={(p) => onChange(p)}
      total={total}
      showSizeChanger={false}
      itemRender={(_, type, originalElement) => {
        if (type === "prev") {
          return (
            <span className="text-[#0F172B] inline-flex items-center gap-1">
              <ChevronLeftIcon className="w-4 h-4" />
              <span>Previous</span>
            </span>
          )
        }
        if (type === "next") {
          return (
            <span className="text-[#0F172B] inline-flex items-center gap-1">
              <span>Next</span>
              <ChevronRightIcon className="w-4 h-4" />
            </span>
          )
        }
        return originalElement
      }}
    />
  )
}

export default CustomPagination
